import {
  Box,
  Button,
  Center,
  Group,
  PasswordInput,
  PinInput,
  Text,
  TextInput,
  UnstyledButton
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconArrowLeft } from '@tabler/icons-react';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createB2BAPI } from '../../../api/Interceptor';
import notify from '../../../utils/Notification';
import B2BButton from '../../common/B2BButton';

export function ForgotPassword() {
  const navigate = useNavigate();
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search);
    const role = queryParams.get('role') || 'customer';
  const userId = JSON.parse(localStorage.getItem('user'))?.userId
  const isCustomer = typeof userId === "string" && userId.startsWith("CUST-");
  const isVendor = typeof userId === "string" && userId.startsWith("VEN-") || /^B\d+$/.test(userId);
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [passwordDto, setPasswordDto] = useState({});
  const [emailError, setEmailError] = useState('')
  const [loading, setLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [timer, setTimer] = useState(30); // 30 seconds timer
  const [isResendDisable, setIsResendDisable] = useState(true);

  const form = useForm({
    initialValues: {
      newPassword: '',
      confirmPassword: ''
    },
    validate: {
      // newPassword: (val) => (val.length <= 6 ? 'Password should include at least 6 characters' : null),
      confirmPassword: (val) => (form.values.newPassword !== val ? 'New Password and Confirm password must be same' : null)
    },
  });
  // Countdown logic
  useEffect(() => {
    if (timer === 0) {
      setIsResendDisable(false);
      return;
    }

    const interval = setInterval(() => {
      setTimer(prevTimer => prevTimer - 1);
    }, 1000);

    // Clear interval when timer reaches 0 or on component unmount
    return () => clearInterval(interval);
  }, [timer]);

 

  const handleEnterKeyPress = (event,toCall) => {
    if (event.key === 'Enter') {
      toCall === 'otp' ? sendOtp(event) : resetPassword();
    }
  };



  const sendOtp = async (event) => {
    event?.preventDefault();
    if (!(/^\S+@\S+$/.test(email))) {
      return setEmailError('Invalid email')
    }
    setEmailError('')
    try {
      setLoading(true)
      const resp = role === 'vendor' ? await B2B_API.post(`reset/vendor/otp?email=${email}`, { json: {} }).json() : await B2B_API.post(`reset/otp?email=${email}`, { json: {} }).json()
      if (resp.message) {
        notify({ title: 'Success', message: 'Otp has been sent to your mail', success: true })
        setShowOtp(true)
        setTimer(30); // Reset timer
        setIsResendDisable(true); // Disable resend button again
      }
    } catch (error) {
      notify({ message: error.message || 'Failed to sent OTP', error: true })

    } finally {
      setLoading(false)
    }
  }

  const resetPassword = async () => {
    setLoading(true)
    try {
      const { newPassword } = form.values;
      passwordDto.newPassword = newPassword;
      const resp = role === 'vendor' ? await B2B_API.post(`reset/vendor/password`, { json: passwordDto }).json():await B2B_API.post(`reset/password`, { json: passwordDto }).json()
      if (resp.response) {
        navigate('/login?role=' + role)
      }
    } catch (error) {
      notify({ message: error.message || "Failed to Reset password", error: true })
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    const verifyOtp = async () => {
      setLoading(true)
      try {
        const resp = role === 'vendor' ? await B2B_API.post(`reset/vendor/verify-otp`, { json: { email: email, otp: otp } }).json() : await B2B_API.post(`reset/verify-otp`, { json: { email: email, otp: otp } }).json()
        setPasswordDto(resp.response)
        setShowOtp(false)
        setShowPassword(true)
      } catch (error) {
        notify({ title: 'Error!!', message: error.message || 'Otp verfication Failed', error: true })
      } finally {
        setLoading(false)
      }
    }

    if (otp.length === 6) {
      verifyOtp()
    }
  }, [B2B_API, email, otp])


  const renderOtp = () => {
    return (
      <div>
        <Text c="dimmed" fz="sm" mb={'1rem'}>We sent a code to <b>{email}</b></Text>
        <Center>
          <PinInput size={"md"} length={6} mb={'1rem'} type={"number"} value={otp} onChange={(value) => setOtp(value)} />
        </Center>
        <Center>
          <Group justify="space-between" mt={5} mb={'0.5rem'} align='baseline'>
            <Text c="dimmed" fz="sm" mb={'lg'}>
              You can resend Otp in {timer} sec
            </Text>
            <Button style={{ fontSize: '0.85rem' }} size='xs' variant='subtle' disabled={isResendDisable} onClick={sendOtp} >
              Resend Otp
            </Button>
          </Group>
        </Center>
      </div>
    )
  }

  const renderPassword = () => {
    return (
      <div>
        <PasswordInput
          className='login-password'
          required
          size='md'
          placeholder="New password"
          value={form.values.newPassword}
          onChange={(event) => form.setFieldValue('newPassword', event.currentTarget.value)}
          error={form.errors.newPassword}
          radius="sm"
        />
        <PasswordInput
          className='login-password'
          required
          size='md'
          placeholder="Confirm password"
          value={form.values.confirmPassword}
          onChange={(event) => form.setFieldValue('confirmPassword', event.currentTarget.value)}
          error={form.errors.confirmPassword}
          onKeyDown={handleEnterKeyPress}
          radius="sm"
        />
      </div>
    )
  }


  return (
    <>
      <div id="login-monday-container" className="login-monday-container">
        <div className="login-monday-content-component">
          <div className="router-wrapper">
            <div className="email-first-component">
              <h1 className="login-header">Forgot Password?</h1>
              {!showOtp && <Text c="dimmed" fz="sm" ta="center" mb={'lg'}>
                Enter your email to get otp
              </Text>
              }
              <form className='login-form' onSubmit={form.onSubmit(() => resetPassword())}>
                <div className='email-password-field'>
                  {!showOtp && <TextInput
                    className='login-email'
                    required
                    size='md'
                    error={emailError}
                    placeholder="ex: support@fabinsta.com"
                    value={email}
                    onKeyDown={(e) => handleEnterKeyPress(e, 'otp')} // Add this handler
                    onChange={(event) => setEmail(event.target.value)}
                    radius="sm"
                  />}
                  {showOtp && renderOtp()}
                  {showPassword && renderPassword()}
                </div>
                <div className='button-container'>
                  {!showOtp && !showPassword && <B2BButton type='button' loading={loading} name={'Send OTP'} variant={"contained"} radius={'5'} style={{ background: 'var(--primary)' }} onClick={sendOtp} />}
                  {showOtp && <B2BButton type='button' loading={loading} disabled={loading} name={'Verify OTP'} variant={"contained"} radius={'5'} style={{ background: 'var(--primary)' }} />}
                  {showPassword && <B2BButton type='submit' loading={loading} disabled={loading} name={'Reset Password'} variant={"contained"} radius={'5'} style={{ background: 'var(--primary)' }} />}
                </div>
              </form>
              <div className="suggest-signup-wrapper">
                <div className="suggest-signup-component">
                  <UnstyledButton onClick={() => navigate('/login?role='+role)} style={{ color: 'var(--mantine-color-dimmed)' }}>
                    <Center inline>
                      <IconArrowLeft size={12} stroke={1.5} />
                      <Box ml={5}>Back to the login page</Box>
                    </Center>
                  </UnstyledButton>
                </div>
              </div>
              <div className="signed-on-accounts-wrapper">
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}